import "./AutomatedOffersFooter.scss";
import SiteFooter from "../../components/ui/SiteFooter";
import brand from "./brands";

function AutomatedOffersFooter() {
	return (
		<SiteFooter className="ao-footer" dark={brand.footer.dark} logos={brand.footer.logos}>
			{brand.footer.notes.map((note) => (
				<p key={note}>{note}</p>
			))}
		</SiteFooter>
	);
}

export default AutomatedOffersFooter;
